import type { TFunction } from 'i18next'

import { AfiUThemeHookResult } from '@components/hooks/useAfiUThemes'

import locales from '@src/config/locales'
import type { SectionLinks, SectionDescriptionLink } from '@src/types/navigation'

export enum TrainingTab {
  TOPIC,
  BUSINESS_PRIORITIES,
  CERTIFICATIONS,
}

type TabConfig =
  | {
      name: string
      key: TrainingTab
      type: 'links'
      sections: SectionLinks[]
    }
  | {
      name: string
      key: TrainingTab
      type: 'descriptions'
      sections: SectionDescriptionLink[]
    }

export function getTrainingTabs(t: TFunction, locale: string, themes: AfiUThemeHookResult) {
  const topicsLinks = getTopicsLinks(t)
  const businessPrioritiesLinks = getBusinessPrioritiesLinks(themes, locale)
  const certificationsLinks = getCertificationsLinks(t)

  const tabs: TabConfig[] = [
    { name: t('topics'), key: TrainingTab.TOPIC, type: 'links', sections: topicsLinks },
    {
      name: t('businessPriorities'),
      key: TrainingTab.BUSINESS_PRIORITIES,
      type: 'descriptions',
      sections: businessPrioritiesLinks,
    },
    {
      name: t('certifications'),
      key: TrainingTab.CERTIFICATIONS,
      type: 'links',
      sections: certificationsLinks,
    },
  ]

  return tabs
}

function getTopicsLinks(t: TFunction): SectionLinks[] {
  return t('topicsTab', {
    returnObjects: true,
  }) as Array<SectionLinks>
}

function getBusinessPrioritiesLinks(
  themes: AfiUThemeHookResult,
  locale: string
): SectionDescriptionLink[] {
  return themes.map((theme) => ({
    title: theme.title[locale],
    description: theme.shortDescription[locale].replace('\n', ' '),
    link: locales[locale].themePathFactory(theme.slug[locale].current),
  })) as Array<SectionDescriptionLink>
}

function getCertificationsLinks(t: TFunction): SectionLinks[] {
  return t('certificationsTab', {
    returnObjects: true,
  }) as Array<SectionLinks>
}
